module.exports = __webpack_public_path__ + "static/media/mobilescreen.aa71459f.png";